export { SpeechRecognizer } from './SpeechRecognition';
export { SpeechSynthesizer, SynthesisGender } from './SpeechSynthesis';



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/CognitiveServices/lib.ts